import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

const trackCompletedSection = (section: string) =>
  pushGTMEvent({
    event: 'Track',
    category: 'checkout',
    action: `completed_${section}`,
    label: '',
    value: 0,
  });

export default trackCompletedSection;
